<template>
    <div id="commodityStore" class="background-ash pl20 pr20 pb20">
        <!--搜索条件-->
        <div class="search_list background-white">
		   <ul class="lists">
                <li>
                    <span>商品ID</span>
                    <el-input size="small"  @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.id" placeholder="请输入商品ID"></el-input>                    
                </li>
                <li>
                    <span>商品名称</span>
                    <el-input size="small"  @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.nameLike" placeholder="请输入商品名称"></el-input>                    
                </li>
                <li>
                    <span>批准文号</span>
                    <el-input size="small"  @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.licenseNumberLike" placeholder="请输入批准文号"></el-input>                    
                </li>
                <li>
                    <span>生产厂家</span>
                    <el-input size="small"  @keyup.native.enter="searchGetDataList" class="width180" v-model="getDataParam.manufacturLike" placeholder="请输入生产厂家"></el-input>                    
                </li>			
				<li>
                    <span>是否禁用</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.status" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="禁用" value="DISABLED"></el-option>
                        <el-option label="启用" value="ENABLED"></el-option>
                    </el-select>                   
                </li>                
            </ul>
			<div class="btns">
                <el-button size="small" type="primary"  @click="searchGetDataList">搜索</el-button>
            </div>
	   </div>
       <!--内容-->
       <div class="pt20 content">
           <!-- 表头操作 -->
           <div class="watchBar">
               <div class="left color-blue">
                   <span>共计商品{{totalCount}}条</span>
                </div>               
                <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
                </div>
            </div>
            <div class="tab">
                <el-table  ref="checkList" :row-key="getRowKey" @selection-change="handleSelectionChange" size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                    <el-table-column type="selection" width="40" fixed :reserve-selection="true"></el-table-column>
                    <el-table-column label="商品ID">
                        <template slot-scope="scope">{{ scope.row.id || '' }}</template>
                    </el-table-column>
                    <el-table-column label="商品名称" prop="name"></el-table-column>           
                    <el-table-column label="通用名" prop="generalName"></el-table-column>                    
                    <el-table-column label="厂家" prop="manufactur"></el-table-column>
                    <el-table-column label="批准文号" prop="licenseNumber"></el-table-column>
                    <el-table-column label="规格" prop="specifications"></el-table-column>
                    <el-table-column label="条形码" prop="barcode"></el-table-column>                   
                    <el-table-column label="状态" >
                        <template slot-scope="scope">                            
                            {{scope.row.status === 'ENABLED' ? '启用' : '禁用'}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">                            
                            <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
               </el-table>
            </div>
            <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList" :current-page.sync="getDataParam.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
       </div>
       <!--编辑-->
       <el-dialog title="编辑" :visible.sync="dialogVisible" width="580px">
            <el-form :model="updateParam" status-icon :rules="rules" ref="commodity" label-width="100px" class="demo-ruleForm">
                <el-form-item label="商品名称" prop="name">
                    <el-input v-model.trim="updateParam.name" class="width400" placeholder="请输入商品名称" ></el-input>
                </el-form-item>
                <el-form-item label="通用名" prop="generalName">
                    <el-input v-model.trim="updateParam.generalName" class="width400" placeholder="请输入商品通用名" ></el-input>
                </el-form-item>
                <el-form-item label="批准文号">
                    <el-input v-model.trim="updateParam.licenseNumber" class="width400" placeholder="请输入批准文号" ></el-input>
                </el-form-item>
                <el-form-item label="规格" prop="specifications">
                    <el-input v-model.trim="updateParam.specifications" class="width400" placeholder="请输入商品规格" ></el-input>
                </el-form-item>                
                <el-form-item label="厂家" prop="manufactur">
                    <el-input v-model.trim="updateParam.manufactur" class="width400" placeholder="请输入厂家" ></el-input>
                </el-form-item>
                <el-form-item label="条形码">
                    <el-input v-model.trim="updateParam.barcode" class="width400" placeholder="请输入条形码" ></el-input>
                </el-form-item>  
                <el-form-item label="件装量">
                    <el-input v-model.trim="updateParam.pieceLoad" class="width400" placeholder="请输入件装量" ></el-input>
                </el-form-item> 
                <el-form-item label="状态" class="last-form-item">
                   <el-radio-group v-model="updateParam.status">
						<el-radio  label='ENABLED'>启用</el-radio>
						<el-radio  label='DISABLED'>禁用</el-radio>
					</el-radio-group>
                </el-form-item>               
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small"  @click="dialogVisible = !dialogVisible">&emsp;取消&emsp;</el-button>
				<el-button type="primary" size="small" @click="commitUpdate">&emsp;确定&emsp;</el-button>
            </span>
       </el-dialog>
    </div>
</template>

<script>
export default {
	name: 'commodityStore', //数据分析商品库
	data () {
		return {
            id: 0,
			getDataParam: {
                nameLike: '',
                licenseNumberLike: '',
                specificationsLike: '',
                manufacturLike: '',
                status: 'all', //ENABLED 启用  DISABLED 禁用
                page:1,
                size:10
            },
            dataList: [],
            dialogVisible: false,
            updateParam: {},
            rules: {
                name:[{required:true,message:'请输入商品名称',trigger:'blur'},
                            { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur' }],
                generalName:[{required:true,message:'请输入通用名称',trigger:'blur'},
                            { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur' }],
                specifications:[{required:true,message:'请输入规格',trigger:'blur'},
                            { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur' }],
                manufactur:[{required:true,message:'请输入厂家',trigger:'blur'},
                            { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur' }]
            },
            totalCount: 0,
            checkList: []
		}
	},
	watch: {	
        dialogVisible(val) {
            if (!val) {
                this.$refs.commodity.resetFields();
            }
        }	
	},
	methods: {
		getDataList () {            
            let param = {...this.getDataParam};
            param.page = (param.page-1); 
            if (param.status === 'all') {
                param.status = null;
            }
            this.$http('POST', '/admin/product/page', {}, param, (status, res) => {               
                if (status) {
                   if(!!res.content && res.content.length > 0) {
                       this.dataList = res.content;                       
                   }else {
                       this.dataList = [];
                   }
                   this.totalCount = res.totalCount;
                }
            })
        },
        searchGetDataList () {
            this.getDataParam.page = 1;
            this.getDataList();
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        //编辑
        editRow (item) {
            // this.updateParam = item;
            this.$http('POST', '/admin/product/view', {}, {id: item.id}, (status, res) => {
                if (status) {
                   if(!!res.data) {
                       this.updateParam = res.data;
                       this.dialogVisible = true;
                   }
                }
            });            
        },
        //修改提交
        commitUpdate () {
            this.$refs.commodity.validate( (validator) => {
                if (validator) {
                    this.$http('POST', '/admin/product/save', {}, this.updateParam, (status, res) => {
                        if (status) {
                            this.$message({type: 'success', message: res.message});
                            this.dialogVisible = false;
                            this.getDataList();
                        }
                    })
                }
            })
        },
        getExport () {
            let param = {...this.getDataParam};
            if (param.status === 'all') {
                param.status = null;
            }   
            const loading = this.load();
            this.$http('POST', '/admin/product/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                   if (res.status === '200') {
                       this.educe(res.data);
                   }
                }
            })
        },
        handleSelectionChange (select) {
            this.checkList = select.map( (item) => { return item.id});
        }, 
        //勾选复选框
        getRowKey (row) {
            return row.id
        },
	},
	mounted () {
        this.getDataList();
		console.log('。。。。。。。。。。。。。。',this.id);
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#commodityStore {width: 100%;height: calc(100vh - 132px);}
#commodityStore .content {height: calc(100% - 76px);}
#commodityStore .content .tab {height: calc(100% - 125px);}
#commodityStore >>>.el-table th.type>.cell, #commodityStore >>>.el-table td.type>.cell {margin-left: 75px;}
#commodityStore >>>.width400.el-input{width: 400px; height: 36px; border-radius: 2px;}
#commodityStore >>>.width400.el-input .el-input__inner{width: 400px; height: 36px; border-radius: 2px;}
#commodityStore >>>.el-select.width400{width:400px; line-height: 36px;}
#commodityStore >>>.el-select.width400 .el-input__inner{height: 36px; border-radius: 2px;}
</style>



// WEBPACK FOOTER //
// src/views/dataAnalysis/commodityStore.vue